/**
 * Geographic utility functions.
 *
 * Extracted from api/ handlers so they can be unit-tested and reused.
 */

/** Haversine distance between two lat/lon points in km */
export function haversineKm(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/** Check if coordinates fall within US boundaries (continental + Hawaii + Alaska) */
export function isInUS(lat: number, lon: number): boolean {
  const continental = lat >= 24 && lat <= 50 && lon >= -130 && lon <= -65;
  const hawaii = lat >= 18.5 && lat <= 22.5 && lon >= -161 && lon <= -154;
  const alaska = lat >= 51 && lat <= 72 && lon >= -180 && lon <= -129;
  return continental || hawaii || alaska;
}

/** Validate NDBC buoy station ID format (alphanumeric, 3-8 chars) */
export function isValidStationId(id: string): boolean {
  return /^[A-Za-z0-9]{3,8}$/.test(id);
}

/** Format a Date to "YYYY-MM-DD HH:MM" */
export function formatTime(d: Date): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
}
